import React from "react";

type MealItem = {
  name: string;
  calories: number;
  protein: number;
  carbs: number;
  fat: number;
};

type MealsMap = {
  Breakfast?: MealItem[];
  Lunch?: MealItem[];
  Dinner?: MealItem[];
  Snacks?: MealItem[];
};

type FoodPlan = {
  meals: MealsMap;
};

export const FoodPlanViewer: React.FC<{ plan?: FoodPlan | null }> = ({
  plan,
}) => {
  const renderMeal = (title: string, items?: MealItem[]) => {
    if (!items || items.length === 0) return null;
    return (
      <section
        key={title}
        style={styles.mealCard}
        aria-label={`${title} meals`}
      >
        <h3 style={styles.mealTitle}>{title}</h3>
        <ul style={styles.itemList}>
          {items.map((it, idx) => (
            <li key={idx} style={styles.itemRow}>
              <span style={styles.itemName}>{it.name}</span>
              <span style={styles.nutrition}>
                {it.calories} kcal • {it.protein}g P • {it.carbs}g C • {it.fat}g
                F
              </span>
            </li>
          ))}
        </ul>
      </section>
    );
  };

  if (!plan) {
    return <div style={styles.placeholder}>Loading assigned food plan…</div>;
  }

  const { Breakfast, Lunch, Dinner, Snacks } = plan.meals || {};

  return (
    <div style={styles.container}>
      <h2 style={styles.sectionTitle}>Assigned Food Plan</h2>
      {renderMeal("Breakfast", Breakfast)}
      {renderMeal("Lunch", Lunch)}
      {renderMeal("Dinner", Dinner)}
      {renderMeal("Snacks", Snacks)}
    </div>
  );
};

const styles: { [k: string]: React.CSSProperties } = {
  container: {
    padding: 12,
    background: "#1a1a1a",
    borderRadius: 12,
    color: "#fff",
    marginBottom: 16,
  },
  sectionTitle: {
    fontSize: 18,
    margin: "6px 0 12px 0",
  },
  mealCard: {
    background: "#2a2a2a",
    borderRadius: 8,
    padding: 12,
    marginBottom: 12,
  },
  mealTitle: {
    margin: "0 0 8px 0",
    fontSize: 16,
  },
  itemList: {
    listStyle: "none",
    padding: 0,
    margin: 0,
  },
  itemRow: {
    display: "flex",
    justifyContent: "space-between",
    padding: "6px 0",
    borderBottom: "1px solid #3a3a3a",
  },
  itemName: {
    fontWeight: 500,
  },
  nutrition: {
    color: "#d0d0d0",
    fontSize: 12,
  },
  placeholder: {
    padding: 12,
    color: "#bbb",
  },
};

export default FoodPlanViewer;
